module.exports = __webpack_public_path__ + "static/Advantage01@2x.56fc4cea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Advantage01@2x.png
// module id = 684
// module chunks = 216210090109534